// extracted by mini-css-extract-plugin
export default {"root":"pending-approval-badge_root__DcBP9","note":"pending-approval-badge_note__mDFxx","icon":"pending-approval-badge_icon__WbvoT"};